import {
  type GetBreakdownCSVArgs,
  useLazyGetSessionsCsvQuery,
} from '@carboncopyco/data';
import { DownloadOutlineIcon } from '@carboncopyco/icons';
import { Button, TooltipBubble, notify } from '@carboncopyco/ui';
import { useDemoAnalytics, useTourAnalytics } from '@carboncopyco/utils';
import { useBoolean } from 'ahooks';

interface DownloadCsvProps {
  params: GetBreakdownCSVArgs;
  disabled?: boolean;
  location: string;
}

export const DownloadCsvButton = ({
  params,
  disabled,
  location,
}: DownloadCsvProps) => {
  const { resourceTypes } = params;
  const [getDownloadCsv] = useLazyGetSessionsCsvQuery();
  const [isDownloading, setIsDownloading] = useBoolean();
  const { trackDemoClickDownloadActivityTable } = useDemoAnalytics(location);
  const { trackTourClickDownloadActivityTable } = useTourAnalytics({
    location,
  });

  return (
    <TooltipBubble
      placement="top"
      title="Download CSV file"
    >
      <Button
        disabled={disabled || isDownloading}
        label="CSV"
        leftIcon={<DownloadOutlineIcon size={20} />}
        secondary
        small
        onClick={() => {
          resourceTypes[0] === 'tour'
            ? trackTourClickDownloadActivityTable({})
            : trackDemoClickDownloadActivityTable({});
          setIsDownloading.setTrue();
          getDownloadCsv(params)
            .unwrap()
            .then((csv) => {
              const anchor = document.createElement('a');
              anchor.href = csv.signedUrl;
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
            })
            .catch(() =>
              notify.error('Report generation failed, please try again')
            )
            .finally(setIsDownloading.setFalse);
        }}
      />
    </TooltipBubble>
  );
};
